import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { TextField, makeStyles, Button } from "@material-ui/core";
import ReCAPTCHA from "react-google-recaptcha";

import companyProfileActions from "../actions/companyProfile.actions";

import bgImg from "../assets/imgs/QR_bg_img.JPG";
import styled from "styled-components";
var validator = require("email-validator");

const useBrandStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    marginBottom: "20px",
    [theme.breakpoints.up("sm")]: {
      marginRight: "620px",
    },
  },
  campaignBanner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  form: {
    padding: "20px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    background: "white",
  },
  submit: {
    marginTop: "10px",
    // width:"10%"
  },
  captch: {
    display: "flex",
    justifyContent: "center",
  },
}));

const StyledBtn = styled(Button)`
  color: #fff !important;
  border-color: #000 !important;
  background-color: #3f3f3f !important;
  padding-left: 25px;
  padding-right: 25px;
  margin: auto;
`;

const StyledTextField = styled(TextField)`
  margin-bottom: 10px;
  background: white!important;
  border-color: black!important;
  * {
    border-color: black!important;
  }
  label {
    color: gray!important
  }
  input {
    color: black!important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s !important;
    -webkit-text-fill-color: black !important;
  }
`;


function Brand() {
  const dispatch = useDispatch();
  let { brand_slug, campaignID } = useParams();
  const classes = useBrandStyles();
  const campaign = useSelector((state) => state.companyBrandReducer.campaign);

  const message = useSelector((state) => state.companyBrandReducer.message);

  const [email, setEmail] = useState("");
  const [capthaValue, setCapthaValue] = useState("");
  const reCaptchaRef = useRef();

  const onChange = (value) => {
    if (!validator.validate(email.trim())) {
      dispatch({
        type: "SET_USER_MESSAGE",
        payload: {
          message: 'Invalid Email address',
          type: "ERROR",
        },
      });
      return;
    }
    let payload = {
      emailAddress: email ? email.trim() : "",
      brandSlug: brand_slug,
      campaignId: campaignID,
      gRecaptchaResponse: value,
    };
    dispatch(companyProfileActions.postCampaignsDetails(payload));
    reCaptchaRef.current.reset()
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    reCaptchaRef.current.execute();
  };

  const [error, setError] = useState(null);

  useEffect(() => {
    dispatch(companyProfileActions.getCompanyDetails(brand_slug, campaignID, (err)=>{setError(err)}));
  }, [dispatch, campaignID, brand_slug]);

  return (
    <div style={{ height: "100%", background: "white", color: "black" }}>
      <div
        style={{
          backgroundSize: "cover",
          height: "100px"
        }}
      >
        {!error && campaign && (
          <div
            style={{
              background: "white",
              height: "100px",
              width: "100px",
              margin: 'auto',
              bottom: "20px",
              left: "20px",
              paddingTop: '40px',
              boxSizing: 'border-box',
              textAlign: "center"
            }}
          >
            <img
              src={`${campaign.brand.logo}`}
              alt="brand logo"
              style={{ height: "100%" }}
            />
          </div>
        )}
        {
          !error &&
          <h2 style={{ textAlign: "center", margin: "20 0" }}>
            {campaign && campaign.brand ? campaign.brand.brandName : ""}
          </h2>
        }
        {
          !error && !message &&
          <h4 style={{ color: "black", textAlign: "center", marginTop: "20px" }}>
            Enter your email address to receive reward from
          </h4>
        }
        {(!message && !error)? (
          <form onSubmit={handleSubmit} className={classes.form}>
            <StyledTextField
              variant="outlined"
              style={{ marginBottom: "10px", width: "100%", maxWidth: "300px" }}
              label="Email Adress"
              onChange={(event) => setEmail(event.target.value)}
            />
            <ReCAPTCHA
              ref={reCaptchaRef}
              size="invisible"
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
              onChange={onChange}
            />
            <StyledBtn
              color="primary"
              variant="contained"
              type="submit"
              style={{ width: "100%", maxWidth: "300px", marginTop: "10px" }}
            >
              Submit
            </StyledBtn>
          </form>
        ) : (
          (
            <div style={{ display: "flex", justifyContent: "center", padding: '20px' }}>
              {error || message}
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default Brand;
